import { defineMessages } from 'react-intl';

export default defineMessages({
  remindPassword: 'Przypomnij hasło',
  insertEmail: 'Wpisz adres e-mail na który ma zostać wysłany link pozwalający na zresetowanie hasła.',
  emailAddress: 'Adres e-mail',
  send: 'Wyślij',
});
